<template>
    <label class="col-md-12">
        <span class="col-md-6">
            {{ question.question }}<span v-if="question.required" class="required-asterisk">*</span>
        </span>
        <component
            :is="getInputType(question.type)"
            v-model="value"
            :name="question.id"
            :min="question.min"
            :max="question.max"
            @isBelowThreshold="setBelowThreshold"
            :threshold="question.threshold"
            :class="questionClass"
        />
    </label>
</template>

<script>
import QuestionInteger from "./question-integer";
import QuestionBoolean from "./question-boolean";
import QuestionText from "./question-text";

export default {
    name: "question-base",
    components: {QuestionText, QuestionBoolean, QuestionInteger},

    data() {
        return {
            value: null,
            below_threshold: false,
            answer_class: 'col-md-3 pull-right'
        }
    },

    props: {
        question: {
            type: Object,
            required: true
        },
    },
    computed: {
        questionClass() {
            const inputType = {
                'boolean': 'col-md-2 pull-right',
                'text': 'col-md-12',
                'integer': 'col-md-2 pull-right',
                'default': 'col-md-3 pull-right'
            }

            return inputType[this.question.type] || inputType['default']
        }
    },
    methods: {
        setBelowThreshold(value) {
            this.below_threshold = value
        },
        getInputType(type) {
            const inputType = {
                'boolean': 'QuestionBoolean',
                'text': 'QuestionText',
                'integer': 'QuestionInteger',
                'default': 'QuestionText'
            }

            return inputType[type] || inputType['default']
        },
    },
    watch: {
        value: function (newVal) {
            this.$emit('input', newVal);
        },
        below_threshold: function (newVal) {
            this.$emit('isBelowThreshold', newVal);
        },

    }
}
</script>

<style scoped>
    .required-asterisk {
        color: red;
    }
</style>
